import { MembershipTemplate } from '@/constants';
import { apiFetch } from '@/utils';
import useSWR from 'swr';

interface TemplatesResponse {
  success: boolean;
  data: MembershipTemplate[];
}

export const useAvailableMemberships = () => {
  const { data, isLoading } = useSWR<TemplatesResponse>(
    '/v1/memberships/templates?activeOnly=true',
    async () => {
      const response = await apiFetch('/v1/memberships/templates?activeOnly=true', {
        withCredentials: false,
      });

      return response.json();
    }
  );

  return {
    templates: data?.data || [],
    isLoading,
  };
};
